import { useDataValue } from 'Simple/Data.js'
import { uuid } from 'Data/validate.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
      app_id: props.appId,
    },
    pause: !location_id || !props.appId,
  }
}
